import { GenerateName } from "../functions/CommonFunction"
import { UserDetails } from "../types/UserDetails"

const useRoles = (userDetailsData: UserDetails) => {
  let isEmployee = false
  let isAdmin = false
  let isManager = false
  let isOwner = true // Bruh Moment
  let companyId = 0
  let isReviewer = false
  let fullName = ""
  let isCleaner = false
  let isMaintain = false

  // In Owner's there's no service_type
  // if (userDetailsData && !userDetailsData?.data?.service_type) {
  //   window.localStorage.removeItem("accessToken")
  // }

  if (userDetailsData) {
    isEmployee = userDetailsData?.data?.role === "Employee"
    isAdmin = ["Admin", "GSAdmin", "SysAdmin"].includes(userDetailsData?.data?.role)
    isManager = userDetailsData?.data?.role === "Manager"
    isOwner = userDetailsData?.data?.role === "owner"
    fullName = GenerateName(userDetailsData.data.first_name, userDetailsData.data.last_name)
    companyId = userDetailsData?.data?.cleaningcompanies_id
    isReviewer = userDetailsData?.data?.is_task_reviewer

    if (userDetailsData?.data?.service_type) {
      isCleaner = userDetailsData?.data?.service_type === "Cleaning"
      isMaintain = userDetailsData?.data?.service_type !== "Cleaning" && userDetailsData?.data?.service_type !== ""
    }
  }

  return { isAdmin, isEmployee, companyId, isReviewer, isManager, isOwner, fullName }
}

export default useRoles
